import type { PlanarGraphLoops } from "geom/planarGraph";
import { planarGraphHalfEdgeStripToPolyLine2 } from "geom/planarGraph";
import { oppositeHalfEdgeIndex } from "geom/polyclip/dcelFromPolygons";
import type { PolygonPlanarGraph } from "geom/polygonPlanarGraph";
import type { PolyLine2 } from "geom/polyLine2Types";

/**
 * Extract a strip of half edges from a planar graph and collate the data mapped to polygons to the output perimeter polygons.
 *
 * @param planarGraph
 * @param perimeterLoops Loops of half edges that define the strip of the planar graph to be extracted.
 * @param polygonData Data mapped to the edges of the planar graph.
 * @returns
 */
export function planarGraphHalfEdgeStripWithData<T>(
  planarGraph: PolygonPlanarGraph,
  perimeterLoops: PlanarGraphLoops,
  polygonData: T[][][],
) {
  const perimeterPolygons: PolyLine2[] = [];
  const polygonDataOut: T[][][] = [];

  for (const loop of perimeterLoops.faceHalfEdges) {
    const loopData: T[][] = [];
    for (const halfEdge of loop) {
      const r = planarGraph.halfEdgeIndexToPolygonEdgeRef(oppositeHalfEdgeIndex(halfEdge));
      if (!r) {
        loopData.push([]);
        continue;
      }
      const { index, edgeIndex } = r;
      const result = polygonData[index][edgeIndex];
      loopData.push(Array.isArray(result) ? [...result] : [result]);
    }
    polygonDataOut.push(loopData);
    perimeterPolygons.push(planarGraphHalfEdgeStripToPolyLine2(planarGraph.planarGraph, loop));
  }

  return { perimeterPolygons, polygonData: polygonDataOut };
}
